import React from "react"

import { formatUsd } from "../utils"

export const LimitDiffCell: React.FC<{ limit: number; prevLimit: number | null; showDiff: boolean }> = ({ limit, prevLimit, showDiff }) => {
  if (!showDiff || prevLimit === null) return <>{formatUsd(limit)} USD</>

  const delta = limit - prevLimit

  return (
    <span className="inline-flex items-center gap-1">
      <span className="text-gray-500 dark:text-gray-400 line-through">{formatUsd(prevLimit)}</span>
      <span>→</span>
      <span className="font-semibold">{formatUsd(limit)} USD</span>
      {delta !== 0 && (
        <span className={delta > 0 ? "text-emerald-500" : "text-rose-500"}>
          ({delta > 0 ? "+" : "-"}
          {formatUsd(Math.abs(delta))})
        </span>
      )}
    </span>
  )
}
